/**
 * Theme specific scripts goes here
 */

// Select the sticky header
var stickyHeader = document.querySelector('sticky-header');
const html = document.querySelector('html');
let prevScrollPos = window.scrollY;
// Function to check if the sticky header is at the top
function checkStickyHeaderPosition() {
    const currentScrollPos = window.scrollY;
    const distanceFromTop = html.scrollTop
    if (distanceFromTop > 100) {
        stickyHeader.classList.remove('transparent');
    } else {
        stickyHeader.classList.add('transparent');
    }

    if (prevScrollPos > currentScrollPos) {
        stickyHeader.style.transform = "translateY(0)";
    } else {
        if (distanceFromTop > 100) {
            stickyHeader.style.transform = "translateY(-100%)";
        }
    }

    prevScrollPos = currentScrollPos;
}



// Call the function whenever the window is scrolled
window.onscroll = checkStickyHeaderPosition;